/* eslint-disable no-useless-escape */

const ID_REGEX = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;

export function extractYoutubeId(value) {
  const match = value.match(ID_REGEX);
  if (match && match[2].length === 11) {
    return match[2];
  } else {
    return null;
  }
}

/* eslint-enable no-useless-escape */



// WEBPACK FOOTER //
// ./src/utils/youtube.js